module.exports = __webpack_public_path__ + "img/create-from-previous.5053a158.png";